import template from "./stripe-card-element.html";

const StripeCardElementComponent = {
  bindings: {
    card: "=",
    cardError: "=",
  },
  template: template,
  controller: class StripeCardElementController {
    /* @ngInject */
    constructor($rootScope, Stripe) {
      this.$rootScope = $rootScope;
      this.Stripe = Stripe;
    }

    $onInit() {
      const elements = this.Stripe.elements({
        locale: this.$rootScope.organization.settings.appLanguage,
      });
      const style = {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };

      this.card = elements.create("card", { style: style });
      this.card.mount("#card-element");

      this.card.addEventListener("change", (event) => {
        if (event.error) {
          this.cardError = event.error.message;
        } else {
          this.cardError = null;
        }
        this.$rootScope.$applyAsync();
      });
    }
  },
};

export default StripeCardElementComponent;
